import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: p, style: r, ...m }) => {
  const v = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-xueyuan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-å­¦é¢"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M3.835 9.272c-1.103.49-1.116 2.05-.022 2.558l.114.054v6.028a.827.827 0 1 0 1.654 0v-5.26l1.565.729v8.977a4.74 4.74 0 0 0 2.927 4.38 15.495 15.495 0 0 0 11.854 0 4.74 4.74 0 0 0 2.927-4.38v-.872a.827.827 0 1 0-1.653 0v.872a3.087 3.087 0 0 1-1.907 2.852 13.843 13.843 0 0 1-10.588 0 3.087 3.087 0 0 1-1.907-2.852v-7.994l4.61 2.022a6.449 6.449 0 0 0 5.182 0l4.61-2.023v3.289a.827.827 0 1 0 1.653 0V13.38l3.333-1.55c1.094-.51 1.08-2.07-.022-2.56L18.28 4.885a5.622 5.622 0 0 0-4.562 0L3.835 9.272Zm1.17 1.29 9.322 4.335a3.969 3.969 0 0 0 3.347 0l9.321-4.336-9.385-4.166a3.968 3.968 0 0 0-3.22 0L5.005 10.56Z",
        fillRule: "evenodd",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = f;
export {
  E as default
};
